import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMassengerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
    fill="none"
    viewBox="0 0 23 23"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m2.875 19.167 1.246-3.738c-1.077-1.592-1.466-3.478-1.096-5.307.37-1.828 1.474-3.475 3.108-4.634s3.685-1.751 5.773-1.667c2.089.085 4.07.84 5.58 2.127 1.507 1.286 2.439 3.016 2.62 4.867s-.4 3.697-1.635 5.196c-1.236 1.499-3.041 2.548-5.081 2.952s-4.176.136-6.01-.755z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.5 11.5v.01M7.668 11.5v.01M15.332 11.5v.01"
    />
  </svg>
);
export default SvgMassengerIcon;
